module.exports = __webpack_public_path__ + "assets/img/download-btn-767a6eac.png";